/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_ResyncingInputs */



/**
* | output |
* | --- |
* | "Syncing..." |
*
* @param {Profile_ResyncingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_resyncing = /** @type {((inputs?: Profile_ResyncingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_ResyncingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synchronisation...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronizando...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sincronizando...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sincronizzazione...")
	return /** @type {LocalizedString} */ ("Syncing...")
});